import { ignoreElements, merge, type Observable, type Subject, tap } from 'rxjs';

/** Configuration for subject resetter. */
type ResetConfiguration<T> = {

  /** Subject. */
  readonly subject$: Subject<T>;

  /** Value to set. */
  readonly valueToSet: T;

  /** Observables that cause the `subject` to be reset with `valueToSet`. */
  readonly observables: readonly Observable<unknown>[];
};

/**
 * Observable side effect that resets the subject whenever one of the observables emits a value.
 * @param param0 Reset configuration.
 */
export function resetSubjectOnChange<T>({
  observables,
  subject$,
  valueToSet: value,
}: ResetConfiguration<T>): Observable<never> {
  return merge(
    ...observables,
  ).pipe(
    tap(() => subject$.next(value)),
    ignoreElements(),
  );
}
